import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Input from "@material-ui/core/Input";
import SelectBlocks from "../Manzanas/SelectBlocks";

const useStyles = makeStyles(theme => ({
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  modalInput: {
    marginBottom: theme.spacing(2)
  }
}));

const ImportLots = ({
  idBlock,
  blocks,
  handleImportSubmit,
  handleFileSelect,
  importModalOpen,
  handleImportClick,
  handleImportClose
}) => {
  const classes = useStyles();
  /*const handleImportSubmit = () => {
    if (selectedFile) {
      onImport(selectedFile);
    }
    setImportModalOpen(false);
    setSelectedFile(null);
  };*/

  /* const onImport = () => {
    const workbook = XLSX.read(file, { type: "binary" });
    const sheet = workbook.Sheets[workbook.SheetNames[0]];
    const rows = XLSX.utils.sheet_to_json(sheet);
    const validRows = rows.filter(row => {
    const isValid = true; 
      return isValid;
    });

    if (validRows.length === 0) {
      // Notificar al usuario de que no se encontraron datos válidos en el archivo
      return;
    }

    // Crear arreglo con los datos de los lotes
    const lotes = validRows.map(row => ({
      numero: row.numero,
      superficie: row.superficie,
      tipo: row.tipo,
      costo: row.costo,
      idManzana: idBlock
    }));

    // Enviar datos al servidor y agregar a la base de datos
    fetch("/api/lotes/import", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(lotes)
    })
      .then(res => res.json())
      .then(data => {
        // Notificar al usuario de los resultados de la importación
        if (data.success) {
          //showMessage("Lotes importados correctamente", "success");
        } else {
          //showMessage(`Error al importar lotes: ${data.error}`, "error");
        }
      })
      .catch(error => {
        // Notificar al usuario de un error en la importación
        //showMessage(`Error al importar lotes: ${error.message}`, "error");
      });
  };
*/
  return (
    <>
      {/* Modal de importación */}
      <Dialog
        open={importModalOpen}
        onClose={handleImportClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle className={classes.formControl} id="form-dialog-title">
          Importar desde Excel
        </DialogTitle>
        <DialogContent>
          {idBlock && (
            <>
              <SelectBlocks idBlock={idBlock} blocks={blocks} selectedBlock />
            </>
          )}
          <Input
            className={classes.modalInput}
            type="file"
            onChange={handleFileSelect}
          />
          <Button onClick={handleImportSubmit} variant="contained">
            Importar
          </Button>
        </DialogContent>
        <DialogActions>
          <Button color="danger" onClick={handleImportClose}>
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
ImportLots.propTypes = {
  idBlock: PropTypes.number,
  blocks: PropTypes.array,
  onImport: PropTypes.func.isRequired,
  handleImportSubmit: PropTypes.func.isRequired,
  handleFileSelect: PropTypes.func.isRequired,
  importModalOpen: PropTypes.bool.isRequired,
  handleImportClick: PropTypes.func.isRequired,
  handleImportClose: PropTypes.func.isRequired
};

export default ImportLots;
